<template>
    <div class="row mx-n2">
        <div class="col-auto px-2">
            <div class="d-flex align-items-center justify-content-center" style="min-width: 30px; min-height: 30px">
                <template v-if="detail.type === 'calendar'">
                    <Icon name="details-calendar" width="25" height="25" />
                </template>
                <template v-else>
                    <Icon :name="`details-${detail.type}`" width="30" height="30" />
                </template>
            </div>
        </div>
        <div class="col px-2">
            <div class="cursus-content course-page__detail-text">
                <CustomText :content="detail.text" />
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from "./Icon";
    import CustomText from "./CustomText";

    export default {
        components: {
            CustomText,
            Icon,
        },
        props: {
            detail: Object,
        }
    }
</script>
